import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Trash2, Webhook } from "lucide-react";
import { toast } from "sonner";
import { createWebhook, deleteWebhook } from "../../api/admin";
import { NeuButton, NeuCard, NeuInput, NeuSelect } from "../../components/neu/Neu";

export const WebhookPanel = ({ hooks, events, deliveries, reload }) => {
  const { t } = useTranslation();
  const [form, setForm] = useState({ url: "", event: "", secret: "" });
  const event = form.event || events[0] || "";

  const add = async () => {
    if (!form.url || !event) return;
    try {
      await createWebhook({ ...form, event });
      setForm({ url: "", event: "", secret: "" });
      toast.success(t("api.created"));
      reload();
    } catch {
      toast.error(t("errors.generic"));
    }
  };

  return (
    <NeuCard data-testid="webhook-panel">
      <p className="label-xs">{t("api.webhooks")}</p>
      <div className="mt-4 grid gap-3 sm:grid-cols-4">
        <NeuInput
          className="sm:col-span-2"
          data-testid="webhook-url"
          placeholder={t("api.url")}
          value={form.url}
          onChange={(e) => setForm({ ...form, url: e.target.value })}
        />
        <NeuSelect data-testid="webhook-event" value={event} onChange={(e) => setForm({ ...form, event: e.target.value })}>
          {events.map((ev) => (
            <option key={ev} value={ev}>
              {ev}
            </option>
          ))}
        </NeuSelect>
        <NeuInput
          data-testid="webhook-secret"
          placeholder={t("api.secret")}
          value={form.secret}
          onChange={(e) => setForm({ ...form, secret: e.target.value })}
        />
      </div>
      <NeuButton variant="primary" className="mt-3" data-testid="webhook-add" onClick={add}>
        {t("api.addWebhook")}
      </NeuButton>

      <ul className="mt-5 space-y-3">
        {hooks.map((h) => (
          <li
            key={h.id}
            data-testid={`webhook-row-${h.id}`}
            className="flex flex-wrap items-center justify-between gap-3 overflow-hidden rounded-2xl border border-border/50 px-4 py-3 shadow-neu-sm"
          >
            <span className="flex min-w-0 items-center gap-2 break-all font-mono text-xs">
              <Webhook className="h-4 w-4 shrink-0 text-primary" />
              {h.url}
            </span>
            <span className="font-mono text-[11px] text-muted-foreground">{h.event}</span>
            <NeuButton
              variant="danger"
              className="px-3 py-2"
              data-testid={`webhook-delete-${h.id}`}
              onClick={async () => {
                await deleteWebhook(h.id);
                reload();
              }}
            >
              <Trash2 className="h-4 w-4" />
            </NeuButton>
          </li>
        ))}
      </ul>

      {deliveries.length > 0 ? (
        <div className="mt-6">
          <p className="label-xs">{t("api.deliveries")}</p>
          <ul className="mt-3 space-y-2 break-all font-mono text-xs text-muted-foreground">
            {deliveries.slice(0, 8).map((d) => (
              <li key={d.id}>
                {d.at?.slice(0, 19)} · {d.event} · {d.status_code}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </NeuCard>
  );
};
